import React from 'react';

const PromoSection: React.FC = () => {
  const promoUrl = "https://enfitah.com/";
  const featureIconUrl = "https://assets.lightfunnels.com/account-1/images_library/4997ff49-882e-45f5-ae17-e89a4fa958e8.dgdsg.svg";
  const mainImageUrl = "https://assets.lightfunnels.com/account-83683/images_library/c12bf5d7-f747-42dd-a994-3ee1278fa0fc.قالب-شوبيفاي-عربي-متعدد-الاستخدامات.webp";

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content Column */}
          <div className="text-right">
            <h2 className="text-3xl md:text-4xl font-bold text-[var(--color-text-heading)] mb-2">
              قالب شوبيفاي عربي
            </h2>
            <p className="text-[15px] text-[var(--color-text-body)] mt-2.5 mb-4 leading-relaxed">
              قالب عربي يوفر تجربة تسوق سلسة ومتجاوب، يرفع من عائداتك لتحقيق المزيد من المبيعات.
            </p>
            
            {/* Feature Box */}
            <div className="flex items-center gap-3.5 p-4 rounded-lg bg-black/5 dark:bg-white/5 mb-4">
              <img src={featureIconUrl} alt="Feature icon" className="h-7 w-auto flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-[var(--color-text-heading)]">
                  قالب واحد… إستخدامات متعددة
                </h3>
                <p className="text-sm text-[var(--color-text-body)]">
                  قالب واحد يفتح لك المجال لبناء أي متجر يخطر في بالك.
                </p>
              </div>
            </div>

            {/* CTA Button */}
            <a
              href={promoUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[var(--color-primary)] text-[var(--color-white)] font-semibold py-3 px-8 rounded-lg hover:bg-[var(--color-primary-hover)] transition-all duration-200 text-xs shadow-lg hover:shadow-xl"
            >
              المزيد من التفاصيل
            </a>
          </div>

          {/* Image Column */}
          <div className="text-center">
            <a href={promoUrl} target="_blank" rel="noopener noreferrer" className="inline-block">
              <img
                src={mainImageUrl}
                alt="قالب شوبيفاي عربي"
                className="w-full h-auto rounded-lg shadow-xl"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoSection;